export const DEFAULT_SURVEY_MESSAGE_COUNT = 8;
const MIN_SURVEY_MESSAGE_COUNT = 1;
const MAX_SURVEY_MESSAGE_COUNT = 50;

export const toSurveyMessageCount = (value: unknown): number | undefined =>
    value === "" || value === undefined || value === null ? undefined : Number(value);

export const normalizeSurveyMessageCount = (value: unknown): number => {
    const count = toSurveyMessageCount(value);
    return count !== undefined && Number.isInteger(count) && count >= MIN_SURVEY_MESSAGE_COUNT && count <= MAX_SURVEY_MESSAGE_COUNT
        ? count
        : DEFAULT_SURVEY_MESSAGE_COUNT;
};
